import {ToastrService} from 'ngx-toastr';
import {Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';

import {AccessControlService} from 'src/app/services/access-control.service';
import {AlertService} from 'src/app/services/alert.service';
import {Router, ActivatedRoute} from '@angular/router';
import {NgForm} from '@angular/forms';
import Swal from 'sweetalert2';
import {Location} from '@angular/common';
import {IDropdownSettings} from 'ng-multiselect-dropdown/multiselect.model';

@Component({
  selector: 'app-add-section-action',
  templateUrl: './add-section-action.component.html',
  styleUrls: ['./add-section-action.component.css']
})
export class AddSectionActionComponent implements OnInit {
  modalRef: BsModalRef;
  @ViewChild('addsectionactionForm') public addsectionactionForm: NgForm;
  @ViewChild('tagForm') public tagForm: NgForm;
  model: any = {};
  id: any;
  section_id: any;
  app_id: any;
  org_id: any;
  application_name: any;
  actionList: any = [];
  app_name: any;
  is_tag = false;
  buttonTitle: any;
  sectionActionId: any;
  module_id: any;
  application: any = [];
  currentDisplayNumber: 0;
  moduleId: any;
  isSavingData = false;
  clientList: Array<any> = [];
  clientRoles: Array<any> = [];
  selectedRoles = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: true
  };
  isLoading: boolean;
  isActionLoading: boolean;
  selectedClient;
  selectedAction;
  isSaving = false;
  seletedActionName;

  constructor(private accesscontrolService: AccessControlService,
              private alertService: AlertService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private _location: Location,
              private modalService: BsModalService,
              private toasterService: ToastrService) {
    // this.section_id = this.activatedRoute.snapshot.params['secid'];
    this.activatedRoute.params.subscribe(params => {
      this.section_id = params['id'];
      this.app_id = params['app_id'];
      this.org_id = localStorage.getItem('org_id');
      // this.getsystemModulebyId();

    });
  }

  openModal(template: TemplateRef<any>) {
    const config = {backdrop: true, ignoreBackdropClick: true};
    this.modalRef = this.modalService.show(template, config);
    //  this.modalRef = this.modalService.show(template);
  }

  openSupportingActionModal(supporting_action: TemplateRef<any>) {
    const config = {backdrop: true, ignoreBackdropClick: true};
    this.modalRef = this.modalService.show(supporting_action, config);
    //  this.modalRef = this.modalService.show(template);
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.moduleId = params['moduleId'];
    });
    this.buttonTitle = 'Save';
    this.getActionBySectionId();
    this.getNextDisplayNumber();
  }

  submit() {
    if (this.buttonTitle + '' == 'Save') {
      this.pushsectionAction();
    } else {
      this.updateSectionAction();
    }
  }

  getActionBySectionId() {
    this.isActionLoading = true;
    this.accesscontrolService.getActionBySectionId(this.section_id, this.app_id, this.moduleId).subscribe((res) => {
        this.model = res['0'];
        this.module_id = this.model._id;
        this.actionList = this.model.section_action;
        if (this.currentDisplayNumber != 0) {
          this.addsectionactionForm.controls.display_order.patchValue(this.currentDisplayNumber);
        }
      }, error => {
        console.log(error);
      },
      () => {
        this.isActionLoading = false;
      });
  }

  getsystemModulebyId() {
    this.accesscontrolService.getsystemModulebyId(this.id).subscribe((res) => {
        debugger;
        this.model = res;
      }, error => {
        // console.log(error)
      },
      () => {
      });
  }

  // addSectionAction() {
  //   this.pushsectionAction();
  // }

  pushsectionAction() {
    const section_action: any = [];
    if (!this.addsectionactionForm.valid) {
      return;
    }
    try {
      const IsExists = false;
      if (this.model) {
        for (let i = 0; i < this.model.section.length; i++) {
          if (this.section_id == this.model.section[i]._id) {
            for (let j = 0; j < this.model.section[i].section_action.length; j++) {
              if (this.model.action_name == this.model.section[i].section_action[j].action_name || this.model.display_order == this.model.section[i].section_action[j].display_order) {
                this.alertService.errorAlert('Section Already Exists Or Section Display Order already used.');
              }

            }
          }
        }
      }
      if (!IsExists) {

        section_action.push(
          {
            value: false,
            action_name: this.model.action_name,
            action_display_name: this.model.action_display_name,
            action_description: this.model.action_description,
            display_order: this.model.display_order,
            permissionType: this.model.permissionType
          });
        this.addSectionAction(section_action);
      }
    } catch (e) {
    }

  }

  addSectionAction(section_action: any) {
    this.isSavingData = true;
    this.accesscontrolService.addSectionAction(this.model._id, this.section_id, section_action, this.app_id).subscribe((res) => {
    }, error => {
      this.isSavingData = false;
      const errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.alertService.errorAlert(errorMessage);
    }, () => {
      this.isSavingData = false;
      this.addsectionactionForm.resetForm();
      this.alertService.updateAlert('Action Added Successfully');
      this.currentDisplayNumber = 0;
      this.getActionBySectionId();
      this.addsectionactionForm.reset();
      this.model = {};
      this.getNextDisplayNumber();
      // this.router.navigate(['section-listing'], { queryParams: { id: this.id } });
    });
  }

  // updates whole module
  addSection_action(excutablecondtion: any) {
    this.accesscontrolService.updatesystemModule(this.model, this.app_id).subscribe((res) => {
    }, error => {
      // //console.log(error)
      const errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.alertService.errorAlert(errorMessage);
    }, () => {
      if (excutablecondtion != 'delete') {
        this.alertService.updateAlert('Action Added Successfully');
      }

      if (excutablecondtion == 'push-tag') {
        this.alertService.updateAlert('Tag Added Successfully');
      }
      if (excutablecondtion == 'update') {
        this.alertService.updateAlert('Action updated Successfully');
        this.buttonTitle = 'Add';
        this.sectionActionId = 'not-set';
      }
      if (excutablecondtion == 'push-supporting-action') {
        this.alertService.updateAlert('supporting Action Added Successfully');
      }

      // this.router.navigate(['/add-section/' + this.id]);
      this.getActionBySectionId();
      this.addsectionactionForm.resetForm();
      // this.tagForm.resetForm();
      // this.getsectionbyid();
    });
  }

  updateSectionAction() {
    this.isSavingData = true;
    if (!this.addsectionactionForm.valid) {
      return;
    }
    try {
      // var IsExists = false;
      if (this.sectionActionId) {
        this.model.action_id = this.sectionActionId;
      }
      this.accesscontrolService.updateSectionAction(this.section_id, this.model, this.app_id).subscribe((res) => {
      }, error => {
        this.isSavingData = false;
        console.log(error);
        const errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.alertService.errorAlert(errorMessage);
      }, () => {
        this.isSavingData = false;
        this.addsectionactionForm.resetForm();
        this.alertService.updateAlert('Action updated Successfully');
        this.getActionBySectionId();
        this.buttonTitle = 'Save';
        this.model.permissionType = undefined;
        // this.router.navigate(['section-listing'], { queryParams: { id: this.module_id } });
      });
    } catch (e) {
    }


  }

  editSectionAction(selected: any) {
    this.sectionActionId = selected._id;
    this.model.action_name = selected.action_name;
    this.model.action_display_name = selected.action_display_name;
    this.model.action_description = selected.action_description;
    this.model.display_order = selected.display_order;
    this.model.permissionType = selected.permissionType || undefined;
    this.buttonTitle = 'Update';
  }
  reset(): void{
    this.addsectionactionForm.resetForm();
  }
  verify(selected: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'Section Action has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.removeAction(selected);
        });
      }

    });
  }

  removeAction(selected: any) {
    for (let i = 0; i < this.model.section.length; i++) {
      for (let j = 0; j < this.model.section[i].section_action.length; j++) {
        if (selected._id == this.model.section[i].section_action[j]._id) {
          this.model.section[i].section_action.splice(j, 1);
        }
      }
    }
    this.addSection_action('delete');
  }

  // back() {
  //   this._location.back();
  // }
  back() {
    this.router.navigate(['section-listing'], {queryParams: {id: this.module_id, app_id: this.app_id}, queryParamsHandling: 'preserve'});
  }

  AddSectionActionTag(selected: any) {
    debugger;
    const action_id = selected._id;
    // debugger
    // var section_action_tags: any = [];
    let IsExists = false;
    if (this.model && (!this.model.tag_name || !this.model.tag_display_name)) {
      return;
    } else {
      //   section_action_tags.push(
      //     {
      //       value: false,
      //       tag_name: this.model.tag_name,
      //       tag_display_name: this.model.tag_display_name
      //     });
      //   this.accesscontrolService.addActionTag(this.module_id, action_id, section_action_tags).subscribe((res) => {
      //   }, error => {
      //     console.log(error)
      //     var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      //     this.alertService.errorAlert(errorMessage)
      //   }, () => {
      //     this.modalRef.hide();
      //     this.addsectionactionForm.resetForm();
      //     this.alertService.updateAlert("Action Added Successfully");
      //     this.getActionBySectionId();
      //     // this.router.navigate(['section-listing'], { queryParams: { id: this.id } });
      //   })
      try {

        if (this.model) {
          for (let i = 0; i < this.model.section.length; i++) {
            for (let j = 0; j < this.model.section[i].section_action.length; j++) {
              for (let k = 0; k < this.model.section[i].section_action[j].section_action_tags.length; k++) {
                if (selected._id == this.model.section[i].section_action[j]._id) {
                  if (this.model.tag_name == this.model.section[i].section_action[j].section_action_tags[k].tag_name) {
                    IsExists = true;
                    this.alertService.errorAlert('Tag Already Set!.');
                  }
                }
              }
            }
          }
        }
        if (!IsExists) {
          for (let i = 0; i < this.model.section.length; i++) {
            for (let j = 0; j < this.model.section[i].section_action.length; j++) {
              if (selected._id == this.model.section[i].section_action[j]._id) {
                this.model.section[i].section_action[j].section_action_tags.push(
                  {
                    value: false,
                    tag_name: this.model.tag_name,
                    tag_display_name: this.model.tag_display_name
                  });
              }

            }
          }
        }
        this.modalRef.hide();
      } catch (e) {
      }
      if (!IsExists) {
        this.addSection_action('push-tag');
      }
    }

  }

  verifyTag(tag: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, remove it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Removed!',
          'Tag has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.removeActionTag(tag);
        });
      }

    });
  }

  removeActionTag(tag: any) {
    for (let i = 0; i < this.model.section.length; i++) {
      for (let j = 0; j < this.model.section[i].section_action.length; j++) {
        for (let k = 0; k < this.model.section[i].section_action[j].section_action_tags.length; k++) {

          if (tag._id == this.model.section[i].section_action[j].section_action_tags[k]._id) {
            this.model.section[i].section_action[j].section_action_tags.splice(k, 1);
          }
        }
      }
    }
    this.addSection_action('delete');

  }

  AddSupportingAction(selected: any) {

    const sectionId = selected._id;
    let IsExists = false;
    if (this.model && (!this.model.supporting_action || !this.model.supporting_action_display_name)) {
      return;
    } else {
      try {

        if (this.model) {
          for (let i = 0; i < this.model.section.length; i++) {
            for (let j = 0; j < this.model.section[i].section_action.length; j++) {
              for (let k = 0; k < this.model.section[i].section_action[j].supporting_actions.length; k++) {
                if (sectionId == this.model.section[i].section_action[j]._id) {
                  if (this.model.supporting_action == this.model.section[i].section_action[j].supporting_actions[k].supporting_action) {
                    IsExists = true;
                    this.alertService.errorAlert('Supporting Action Already Set!.');
                  }
                }
              }
            }
          }
        }

        if (!IsExists) {
          for (let i = 0; i < this.model.section.length; i++) {
            for (let j = 0; j < this.model.section[i].section_action.length; j++) {
              if (sectionId == this.model.section[i].section_action[j]._id) {
                this.model.section[i].section_action[j].supporting_actions.push(
                  {
                    value: false,
                    supporting_action: this.model.supporting_action,
                    supporting_action_display_name: this.model.supporting_action_display_name
                  });
              }

            }
          }
        }
        this.modalRef.hide();
      } catch (e) {
      }
      if (!IsExists) {
        this.addSection_action('push-supporting-action');
      }
    }
  }

  verifySupportingAction(supporting_action: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, remove it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Removed!',
          'Supporting has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.removeSupportingAction(supporting_action);
        });
      }

    });
  }

  removeSupportingAction(supporting_action: any) {
    for (let i = 0; i < this.model.section.length; i++) {
      for (let j = 0; j < this.model.section[i].section_action.length; j++) {
        for (let k = 0; k < this.model.section[i].section_action[j].supporting_actions.length; k++) {

          if (supporting_action._id == this.model.section[i].section_action[j].supporting_actions[k]._id) {
            this.model.section[i].section_action[j].supporting_actions.splice(k, 1);
          }
        }
      }
    }
    this.addSection_action('delete');
  }

  getNextDisplayNumber() {
    this.accesscontrolService.getNextDisplayNumber({
      appId: this.app_id,
      moduleId: this.moduleId,
      sectionId: this.section_id,
      type: 'action'
    }).subscribe((res: any) => {
        if (this.app_id) {
          this.currentDisplayNumber = res.data;
          this.addsectionactionForm.controls.display_order.patchValue(this.currentDisplayNumber);
        }
      },
      error => {

      });
  }

  openAssignActionModel(template, actionId, actionName) {
    this.selectedRoles = [];
    this.selectedClient = null;
    this.selectedAction = actionId;
    this.seletedActionName = actionName;
    this.clientRoles = [];
    this.openModal(template);
    this.getApplicationClients();
  }

  assignActionToRoles() {
    this.isSaving = true;
    const details = {
      moduleId: this.moduleId,
      sectionId: this.section_id,
      actionId: this.selectedAction,
      roles: this.selectedRoles
    };
    this.accesscontrolService.assignActionToRoles(details).subscribe(
      (response: any) => {
        if (!response.error) {
          this.toasterService.success(response.message);
          this.clearAssignRoleData();
        } else {
          this.toasterService.error(response.message);
        }
        this.isSaving = false;
        this.selectedRoles = [];
      },
      (error) => {
        this.isSaving = false;
        this.toasterService.error(error.error.message);
      }
    );
  }

  getApplicationClients() {
    this.isLoading = true;
    this.accesscontrolService.getApplicationClients(this.app_id, this.org_id).subscribe(
      (response: any) => {
        if (!response.error) {
          this.clientList = response.data;
        } else {
          this.toasterService.error(response.message);
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.toasterService.error(error.error.message);
      }
    );
  }

  getClientRoles() {
    this.isLoading = true;
    this.accesscontrolService.getApplicationRoles(this.app_id, this.selectedClient, this.moduleId, this.section_id, this.selectedAction).subscribe(
      (response: any) => {
        console.log(response);
        if (!response.error) {
          this.clientRoles = response.data;
        } else {
          this.toasterService.error(response.message);
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.toasterService.error(error.error.message);
      }
    );
  }

  clearAssignRoleData() {
    this.selectedRoles = [];
    // this.selectedClient=null
    // this.seletedActionName='';
    this.clientRoles = [];
    this.getClientRoles();
  }

  onClose() {
    this.modalRef.hide();
    this.selectedRoles = [];
    this.selectedClient = null;
    this.seletedActionName = '';
  }
}

